import { Checkbox } from "primereact/checkbox";
import { Tree } from "primereact/tree";
import { classNames } from "primereact/utils";
import { useMapURLParams } from "../../../../../../hooks/map/useMapParams";
import { useMapDispatch } from "../../../../../../stateManagement/hooks/useMapDispatch";
import { useMapSlice } from "../../../../../../stateManagement/hooks/useMapSlice";
import { MapName } from "../../../../../../stateManagement/reducers/maps/actions";
import { patchFilterTreeCheckboxState } from "./filterTreeCheckboxFunctions";
import SmallLoader from "../../../../../loaders/SmallLoader";
import { MapTreeCheckboxFilter } from "../types";

type FilterTreeCheckboxProps = {
    filterConfig: MapTreeCheckboxFilter
}

const captionFilter = (caption: string, searchValue: string) => caption?.toLowerCase().includes(searchValue.toLowerCase())

export function FilterTreeCheckbox({ filterConfig }: FilterTreeCheckboxProps) {
    const dispatchMap = useMapDispatch()
    const { canBeIgnored, canIncludeNull, fieldName, hasSearch } = filterConfig ?? {}
    const { mapName } = useMapURLParams() as { mapName: MapName; mapOption?: string };;
    const mapState = useMapSlice(mapName)
    const { mapFiltersState }: any = mapState ?? {};
    const filterState = mapFiltersState?.[fieldName]
    const { isIgnored, includeNull, nodes, searchValue, selectedValues } = filterState ?? {}
    const ignoreInputId = `ignore-${fieldName}`
    const nullInputId = `null-${fieldName}`

    const treeCheckboxContainerClassNames = classNames({
        "tree-checkbox": true,
        "with-search-container": true,
        "filter-ignore": isIgnored
    })

    const showNullInput =
        canIncludeNull &&
        (!hasSearch || captionFilter('Не указан', searchValue));

    const IsIgnoredValueCheckbox = () => (
        <div className="map-hint-filters-checkbox-div">
            <Checkbox
                inputId={ignoreInputId}
                name={ignoreInputId}
                onChange={(event: any) => patchFilterTreeCheckboxState(mapName, fieldName, { isIgnored: event.checked }, dispatchMap)}
                checked={isIgnored}
            />
            <label htmlFor={ignoreInputId} className="ms-2">Не учитывать</label>
        </div>
    )

    const IncludeNullValueCheckbox = () => (
        <div className="map-hint-filters-checkbox-div">
            <Checkbox
                inputId={nullInputId}
                name={nullInputId}
                onChange={(event: any) => patchFilterTreeCheckboxState(mapName, fieldName, { includeNull: event.checked }, dispatchMap)}
                checked={includeNull}
            />
            <label htmlFor={nullInputId} className="ms-2">Не указан</label>
        </div>
    )

    return (
        <div className="filter-tree-checkbox">
            {canBeIgnored && <IsIgnoredValueCheckbox />}
            {hasSearch &&
                <input
                    onChange={(e: any) => patchFilterTreeCheckboxState(mapName, fieldName, { searchValue: e.target.value }, dispatchMap)}
                    value={searchValue}
                    className="tree-checkbox-search"
                />
            }
            <div className={treeCheckboxContainerClassNames}>
                {showNullInput && <IncludeNullValueCheckbox />}
                {nodes
                    ?
                    <Tree
                        value={nodes}
                        filter
                        onFilterValueChange={(e: any) => patchFilterTreeCheckboxState(mapName, fieldName, { searchValue: e.value }, dispatchMap)}
                        filterTemplate
                        filterValue={searchValue}
                        selectionMode="checkbox"
                        selectionKeys={selectedValues}
                        onSelectionChange={(event) => patchFilterTreeCheckboxState(mapName, fieldName, { selectedValues: event.value }, dispatchMap)}
                    />
                    :
                    <SmallLoader />
                }
                {/* {!checkTreeCheckboxHasSearchValue(treeValues, searchValue, 0) && !showNullInput &&
                    <div className="map-hint-filters-checkbox-div">
                        <label className="no-results">Нет результатов</label>
                    </div>
                } */}
            </div>
        </div>
    )
}
